import { ga } from 'js/analytics/adapters'
export const trackSelectPremiumSubscription = ({
  duration,
  discount = 0,
  coupon = '',
  entryPoint = '',
}) => {
  ga.track('select_premium_subscription', {
    subscription_duration: duration,
    discount: discount,
    entry_point: entryPoint,
    coupon,
  })
}
